(() => {
  const initialized = new WeakSet();
  const initialize = (section) => {
  const dialog = section.querySelector('[data-lightbox]');
  if (!dialog || initialized.has(dialog)) return;
  initialized.add(dialog);
  const image = dialog.querySelector('[data-lightbox-image]');
  const title = dialog.querySelector('[data-lightbox-title]');
  const counter = dialog.querySelector('[data-lightbox-counter]');
  const close = dialog.querySelector('[data-lightbox-close]');
  const buttons = [...section.querySelectorAll('[data-gallery-image]')];
  let activeIndex = 0;

  const show = (index) => {
    activeIndex = (index + buttons.length) % buttons.length;
    const button = buttons[activeIndex];
    image.src = button.dataset.galleryImage;
    image.alt = button.dataset.galleryAlt || '';
    title.textContent = button.dataset.galleryTitle || '';
    counter.textContent = `${activeIndex + 1} / ${buttons.length}`;
  };

  section.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gallery-open]');
    if (button && buttons.length) {
      const index = buttons.findIndex((item) => item === button || item.dataset.galleryImage === button.dataset.galleryImage);
      if (index >= 0) {
        show(index);
        if (!dialog.open) dialog.showModal();
      }
      return;
    }
    if (event.target === dialog) dialog.close();
  });

  dialog.querySelector('[data-lightbox-prev]').addEventListener('click', () => show(activeIndex - 1));
  dialog.querySelector('[data-lightbox-next]').addEventListener('click', () => show(activeIndex + 1));
  close.addEventListener('click', () => dialog.close());
  dialog.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') { event.preventDefault(); show(activeIndex - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); show(activeIndex + 1); }
  });
  };
  const initializeAll = () => document.querySelectorAll('.gallery-section').forEach(initialize);
  initializeAll();
  document.addEventListener('shopify:section:load', initializeAll);
})();